const Container = ({ children, ...props }) => {
  return (
    <div className="pl-[288px] pr-[90px] py-[88px] min-h-screen">
      {children}
    </div>
  );
};

export default Container;
